<template>
    <b-field :label="label" :horizontal="horizontal" :type="type" :custom-class="customClass">
        <b-taginput
            v-model="tags"
            :data="filteredTagsList"
            autocomplete
            :allow-new="allowNew"
            :open-on-focus="false"
            field="name"
            :placeholder="placeholder || 'Add a tag'"
            :size="size"
            @typing="getFilteredTags"
            @add="onAdd"
            @remove="onRemove"
        >
            <template slot-scope="props">{{props.option}}</template>
            <template slot="empty">No Result</template>
        </b-taginput>
    </b-field>
</template>
<script>
import { TagService } from "@/services/tag.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import debounce from "lodash/debounce";

export default {
    tagService: TagService,
    props: {
        placeholder: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: null
        },
        horizontal: {
            type: Boolean,
            default: false
        },
        typeNotIncluded:{
            type: String,
            default: null
        },
        onlyType:{
            type: String,
            default: null
        },
        allowNew:{
            type: Boolean,
            default: false
        },
        displayAllOrAny:{
            type: Boolean,
            default: false
        },
        values:{
            type: Array,
            default: () => []
        },
        size: {
            type: String
        },
        type: {
            type: String
        },
        customClass: {
            type: String
        }
    },
    data: () => ({
        tags: [],
        allTags: [],
        filteredTagsList: [],
    }),
    computed: {
        user() {
            return this.$store.state.Auth.user;
        }
    },
    watch:{
        tags(tags){
            this.$emit('selectedTags', tags)
            this.$emit("update:values", tags);
        },
        values(values) {
            this.tags = values;
        }
    },
    created() {
        this.getTags();

        if(this.values){
            this.tags = this.values
        }
    },
    methods: {
        async getTags() {
            try {
                // this.allTags = await this.$options.tagService.all({ typeNotIncluded: this.typeNotIncluded }).then(response => JsonDenormalizer.denormalize(response));

                await this.$options.tagService.all({ typeNotIncluded: this.typeNotIncluded, onlyType: this.onlyType, firm_id: this.user.firmId }).then(response => {

                    let data = JsonDenormalizer.denormalize(response).filter(element => {

                        return element.name.toLowerCase() != 'vendor' && element.name.toLowerCase() != 'customer' && element.name.toLowerCase() != 'colleagues';

                    });

                    this.allTags = data;

                });

                    // console.log(this.allTags);

                // Push All item
                if(this.displayAllOrAny){
                    this.allTags.unshift({name: 'Any'})
                    this.allTags.unshift({name: 'All'})
                }

            } catch (err) {}
        },
        getFilteredTags: debounce(function(filter) {
            this.filteredTagsList = this.allTags
                .filter(option => {
                    return (
                        option.name
                            .toString()
                            .toLowerCase()
                            .indexOf(filter.toLowerCase()) >= 0
                    );
                }).map(tag => tag.name);
        }, 200),
        onAdd(tag) {
            this.$emit("add", tag);
        },
        onRemove(tag) {
            this.$emit("remove", tag);
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/partials/TagsInput.vue